import urls from "../../constants/urls.js";
import axios from "axios";

const state = {
  gateways: [],
  loadingGateways: true,
  // Crowded payout accounts (GET …/crowded/payout-account?gateway_id=), keyed by
  // the base "crowded" gateway id — an org can have several Crowded chapters.
  // Shared by the gateways list header and the payout panel in the gateway
  // modal. Absent = not loaded; { status: "missing" } = no account.
  crowdedPayoutAccounts: {},
};

const mutations = {
  setGateways(state, data) {
    state.gateways = data;
  },

  setLoadingGateways(state, value) {
    state.loadingGateways = value;
  },

  setCrowdedPayoutAccount(state, { gatewayId, account }) {
    state.crowdedPayoutAccounts = { ...state.crowdedPayoutAccounts, [gatewayId]: account };
  },
};

function fetchGateways() {
  let orgId = localStorage.getItem("orgId");
  return axios.get(urls.gateways.replace(":orgId", orgId)).then((response) => {
    let gateways = response.data.data;
    let included = response.data.included;

    let filteredItem = (searched) =>
      included?.filter((item) => item.type === searched.type && searched.id === item.id)?.[0] || [];

    return gateways.map((gateway) => {
      if (gateway.relationships?.cids?.data?.length) {
        gateway.relationships.cids.data = gateway.relationships.cids?.data?.map((cid) => {
          return filteredItem(cid);
        });
      }

      if (gateway.relationships?.charge_currency?.data?.length) {
        gateway.relationships.charge_currency.data =
          gateway.relationships.charge_currency?.data?.map((currency) => {
            return filteredItem(currency);
          });
      }

      return gateway;
    });
  });
}

const actions = {
  getGateways({ commit }) {
    commit("setLoadingGateways", true);
    return fetchGateways().then((gateways) => {
      commit("setGateways", gateways);
      commit("setLoadingGateways", false);
    });
  },

  // Re-fetches gateways without toggling loadingGateways — used to poll for
  // balance_status flipping from "pending" to "ready"/"error" without
  // re-showing the full-list spinner on every tick.
  refreshGateways({ commit }) {
    return fetchGateways().then((gateways) => {
      commit("setGateways", gateways);
    });
  },

  fetchCrowdedPayoutAccount({ commit }, gatewayId) {
    const orgId = localStorage.getItem("orgId");
    return axios
      .get(urls.crowdedPayoutAccount.replace(":oid", orgId), {
        params: { gateway_id: gatewayId },
      })
      .then(({ data }) => {
        commit("setCrowdedPayoutAccount", { gatewayId, account: data });
        return data;
      })
      .catch((e) => {
        // 404 = no such Crowded gateway for this org.
        if (e.response?.status === 404) {
          const missing = { status: "missing" };
          commit("setCrowdedPayoutAccount", { gatewayId, account: missing });
          return missing;
        }
        throw e;
      });
  },

  getGatewaysAndReturn(_, options = {}) {
    let orgId = localStorage.getItem("orgId");
    return axios
      .get(urls.gateways.replace(":orgId", orgId), {
        signal: options.signal,
        params: options.params,
      })
      .then((response) => {
        return response.data.data;
      });
  },
};

export default {
  state,
  actions,
  mutations,
};
